import { ClassFilterType } from "@common/types/class";
import { TransactionFilters } from "@common/schemas/transaction.schema";

export type TransactionsFilters = TransactionFilters;

export type FiltersChangeFn = (payload: Partial<TransactionsFilters>) => void;

export interface FilterProps {
    filters: TransactionsFilters;
    onChange: FiltersChangeFn;
}

export const DEFAULT_FILTERS: TransactionsFilters = {
    search: "",
    requiredAction: false,
    requiredActions: [],
    entityIds: [],
    accountIds: [],
    counterpartiesIds: [],
    customerIds: [],
    transactionRulesIds: [],
    coaAccounts: [],
    accrualCoaAccounts: [],
    classFilterType: ClassFilterType.ANY_SELECTED,
    transactionIds: [],
};
